export default "__VITE_ASSET__0kz1Cw$w__"